module.exports = __webpack_public_path__ + "static/media/Website.64ae3c6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/oldMunafaMart/Website.png
// module id = 412
// module chunks = 0